import { formatDateTime } from "@/utils/format";
import ICON_CORNER from "@/assets/images/corner.svg";
import MatchMinute from "@/components/KbvMatchMinute";
import { MATCH_STATUS } from "@/contants";

export default function MatchTime({
  homeCorner,
  awayCorner,
  isLive,
  isFinished,
  isNotStarted,
  matchTime,
  liveScore,
  status,
  halfStartTime,
  isHorizontal = false,
}) {
  const corners = (
    <div className="flex items-center gap-1 whitespace-nowrap">
      <img src={ICON_CORNER} alt="" width={8} height={8} className="kbv-corner-icon" />
      <span
        className={
          isFinished
            ? "text-sm"
            : "text-sm font-semibold text-[var(--theme-text,#1A1A1A)]"
        }
      >
        {homeCorner}:{awayCorner}
      </span>
    </div>
  );

  const timeClass = `kbv-ltd-time ${isHorizontal ? "" : "is-stacked"}`.trim();

  if (isFinished) {
    return (
      <div className={timeClass}>
        <span className="text-sm font-semibold whitespace-nowrap">KT</span>
        {corners}
      </div>
    );
  }

  if (isNotStarted && matchTime) {
    const { date, time } = formatDateTime(matchTime);
    if (isHorizontal) {
      return (
        <div className={timeClass}>
          <span className="text-sm">{time}</span>
          <span className="text-sm">-</span>
          <span className="text-sm">{date}</span>
        </div>
      );
    }
    return (
      <div className={timeClass}>
        <span className="text-sm">{time}</span>
        <span className="text-sm">{date}</span>
      </div>
    );
  }

  if (isLive) {
    const isPenalty = Number(status) === MATCH_STATUS.PENALTY;
    const hasMinute = liveScore?.minute !== undefined || liveScore?.currentMinute !== undefined;
    return (
      <div className={timeClass}>
        {isPenalty && !hasMinute && !liveScore?.var ? (
          <span className="text-sm text-red-600 leading-[1.2]">
            Pen
            <span style={{ animation: "blink 1s infinite" }}>&apos;</span>
          </span>
        ) : (
          <MatchMinute
            liveScore={liveScore}
            status={status}
            matchTime={matchTime}
            halfStartTime={halfStartTime}
            className="text-sm text-red-600 leading-[1.2]"
          />
        )}
        {corners}
      </div>
    );
  }

  return null;
}
